import { render, staticRenderFns } from "./informacionOT.vue?vue&type=template&id=4c45a0aa&"
import script from "./informacionOT.vue?vue&type=script&lang=js&"
export * from "./informacionOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports